import React from 'react';
import { Info } from '@mui/icons-material';
import Popover from '../../Popover';
import { TooltipContent, TooltipIcon } from './LabelTooltip.style';

/**
 * LabelTooltip Props
 */
interface LabelTooltipProps {
  /**
   * Unique DOM id for the popover. Used to hint to screen readers that the
   * provided children are related to the popover.
   */
  id: string;

  children?: React.ReactNode;
}

const LabelTooltip: React.FC<LabelTooltipProps> = ({ id, children }) => {
  const content = <TooltipContent>{children}</TooltipContent>;

  return (
    <TooltipIcon>
      <Popover
        width="250px"
        content={content}
        placement="top"
        id={id}
        trigger="hover"
      >
        <Info id={`-img-labeltootltip-$id`} aria-describedby={id} />
      </Popover>
    </TooltipIcon>
  );
};

export default LabelTooltip;
